<template>
  <v-dialog v-model="dialog" scrollable width="700">
    <v-card>
      <v-toolbar color="primary" dense class="elevation-0" dark>
        <v-toolbar-title>Thêm đồng phục</v-toolbar-title>
        <v-spacer />
        <v-btn icon dark @click="cancel">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <UniformForm ref="uniformForm" :uniformData="uniformData" />
      </v-card-text>
      <v-divider />
      <v-card-actions class="pa-4">
        <v-btn outlined @click="cancel">HUỶ</v-btn>
        <v-spacer />
        <v-btn color="primary" @click="save">LƯU</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import UniformForm from '@/modules/uniform/UniformForm.vue'
import { mapActions } from 'vuex'

export default {
  components: { UniformForm },
  props: {
    state: Boolean
  },
  data() {
    return {
      dialog: false,
      uniformData: {}
    }
  },
  methods: {
    ...mapActions('Uniformes', ['createUniform', 'uploadImage']),
    cancel() {
      this.dialog = false
      this.uniformData = {}
      if (this.$refs.uniformForm) {
        this.$refs.uniformForm.resetValidation()
        this.$refs.uniformForm.resetDefault()
      }
    },
    async save() {
      if (!this.$refs.uniformForm.validate()) return

      this.$loading.active = true
      try {
        const data = this.$refs.uniformForm.getData()

        const combinations = data.uniformCombinations.map(comb => {
          const clone = { ...comb }
          return clone
        })

        const payload = {
          name: data.name,
          note: data.note,
          academicLevel: data.academicLevel,
          activeStatus: data.activeStatus,
          uniformCombinations: combinations
        }
        const uniform = await this.createUniform(payload)
        if (data.images && data.images.length > 0) {
          const formData = new FormData()
          data.images.forEach((file) => {
            formData.append('files', file)
          })
          formData.append('refId', uniform.id)
          formData.append('ref', 'uniform')
          formData.append('field', 'images')
          await this.uploadImage(formData)
        }

        this.$refs.uniformForm.resetDefault()
        this.dialog = false
        this.$alert.addSuccess()
      } catch (error) {
        this.$alert.addError(error)
      } finally {
        this.$loading.active = false
      }
    }
  },
  watch: {
    state(val) {
      if (val) {
        this.dialog = true
        this.uniformData = {}
      }
    }
  }
}
</script>
